import system from "./system";

export default {
    getSessionTabsValue() {
        return JSON.parse(sessionStorage.getItem("tabsValue"))
    },
    setSessionTabsValue(val) {
        return sessionStorage.setItem("tabsValue",JSON.stringify(val));
    },
    removeTabsValue() {
        return sessionStorage.removeItem('tabsValue')
    }

}
